import useQueryPermissions from './usergroup-use-query-permissions';
import useCanManageUserGroups from './use-can-manage-usergroups';


export const usergroupUseQuery = {
  getPermissions: useQueryPermissions
}

export { useCanManageUserGroups };
